export { getDifficulties } from './connector';
